"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$t = $t;
function getMarsWindow() {
    return typeof window === 'undefined' ? undefined : window;
}
function interpolateMessage(message, values) {
    if (!values || !message) {
        return message;
    }
    return message.replace(/\{(\w+)\}/g, (match, key) => {
        return values[key] !== undefined ? String(values[key]) : match;
    });
}
function findMessageId(defaultMessage) {
    if (!defaultMessage) {
        return undefined;
    }
    const marsWindow = getMarsWindow();
    const packageMessages = marsWindow?.__MARS_PACKAGE_INTL_MESSAGES__;
    const messageList = [
        packageMessages?.zhCN,
        packageMessages?.enUS,
        packageMessages?.current,
    ].filter(Boolean);
    const visitedMessages = new Set();
    for (const messages of messageList) {
        if (visitedMessages.has(messages)) {
            continue;
        }
        visitedMessages.add(messages);
        const matched = Object.entries(messages).find(([, message]) => message === defaultMessage);
        if (matched) {
            return matched[0];
        }
    }
    return undefined;
}
function generateMessageId(descriptor) {
    const source = JSON.stringify({
        defaultMessage: descriptor.defaultMessage || '',
        description: descriptor.description || '',
    });
    let hash = 5381;
    for (let index = 0; index < source.length; index += 1) {
        hash = (hash * 33) ^ source.charCodeAt(index);
    }
    return `packages.${(hash >>> 0).toString(36)}`;
}
/**
 * packages 统一国际化方法，委托运行时 window.$t 并自动解析 message id
 */
function $t(descriptor, values) {
    const marsWindow = getMarsWindow();
    if (!marsWindow?.$t) {
        if (marsWindow && !marsWindow.$t) {
            console.warn('window.$t is not available, returning defaultMessage');
        }
        return interpolateMessage(descriptor.defaultMessage || '', values);
    }
    const finalDescriptor = {
        ...descriptor,
        id: descriptor.id || findMessageId(descriptor.defaultMessage) || generateMessageId(descriptor),
    };
    try {
        return marsWindow.$t(finalDescriptor, values);
    }
    catch (error) {
        return interpolateMessage(descriptor.defaultMessage || '', values);
    }
}
